/*
    TODO
        - add inert support
        - remove parentFocus method
*/
const focusableElements = [
    'a[href]',
    'area[href]',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'button:not([disabled])',
    'iframe',
    'object',
    'embed',
    '[tabindex="0"]',
    '[contenteditable]',
    'audio[controls]',
    'video[controls]',
    'summary',
    '[tabindex^="0"]',
    '[tabindex^="1"]',
    '[tabindex^="2"]',
    '[tabindex^="3"]',
    '[tabindex^="4"]',
    '[tabindex^="5"]',
    '[tabindex^="6"]',
    '[tabindex^="7"]',
    '[tabindex^="8"]',
    '[tabindex^="9"]',
];

const MdsTrapFocus = {
    data() {
        return {
            initialActiveElement: null,
            container: '',
            focusableNodes: null,
            firstFocusableElement: null,
            lastFocusableElement: null,
        };
    },
    methods: {
        // Tabindex setting
        setTabIndex(set = true) {
            if (set) {
                if (this.container && this.$refs[this.container]) {
                    this.$refs[this.container].setAttribute('tabindex', '-1');
                } else {
                    this.$el.setAttribute('tabindex', '-1');
                }
            } else {
                if (this.container && this.$refs[this.container]) {
                    this.$refs[this.container].removeAttribute('tabindex');
                } else {
                    this.$el.removeAttribute('tabindex');
                }
            }
        },
        // Event listener for tabbing
        trapFocusKeyDownEvents(event) {
            if (event.key === 'Tab' || event.keyCode === 9) {
                this.maintainFocus(event);
            }
        },
        // Remove focus
        disableTrapFocus() {
            // To shift focus to current activeElement
            if (
                this.initialActiveElement !== document.activeElement &&
                this.isFocusableElement() &&
                !this.isFocusInsideContainer()
            ) {
                document.activeElement.focus();
            } else if (this.initialActiveElement) {
                this.initialActiveElement.focus();

                // Reset
                this.initialActiveElement = null;
                this.focusableNodes = null;
                this.firstFocusableElement = null;
                this.lastFocusableElement = null;
            }

            this.setTabIndex(false);
            document.removeEventListener('keydown', this.trapFocusKeyDownEvents, true);
        },
        // Start focus
        enableTrapFocus(container, customFirstElement = '') {
            // Get last active element and store reference for later
            if (!this.initialActiveElement) {
                this.initialActiveElement = document.activeElement;
            }

            this.container = container;
            this.setTabIndex();

            // Set up focusable elements ready for tabbing
            setTimeout(() => {
                this.focusableNodes = this.focusableElements();
                this.firstFocusableElement = this.focusableNodes[0];
                this.lastFocusableElement = this.focusableNodes[this.focusableNodes.length - 1];

                // Shift focus
                if (this.focusableNodes.length && customFirstElement) {
                    customFirstElement.focus();
                } else {
                    if (this.focusableNodes.length && !this.container) {
                        this.$el.focus();
                    } else if (this.focusableNodes.length && this.container) {
                        // e.g. page-shell
                        this.firstFocusableElement.focus();
                    } else {
                        const nonfocusableElements = this.parentFocus();
                        if (nonfocusableElements.length) {
                            nonfocusableElements[0].focus();
                        }
                    }
                }
            }, 100);

            // Add listener for tabbing
            document.addEventListener('keydown', this.trapFocusKeyDownEvents, true);
        },
        // Maintain focus during tabbing
        maintainFocus(event) {
            if (event.shiftKey) {
                if (document.activeElement.isEqualNode(this.firstFocusableElement)) {
                    this.lastFocusableElement.focus();
                    event.preventDefault();
                }
            } else {
                if (document.activeElement.isEqualNode(this.lastFocusableElement)) {
                    this.firstFocusableElement.focus();
                    event.preventDefault();
                }
            }
        },

        // Returns all focusable elements
        // https://github.com/jkup/focusable/blob/master/index.js
        focusableElements() {
            const nodes =
                this.container && this.$refs[this.container]
                    ? this.$refs[this.container].querySelectorAll(focusableElements)
                    : this.$el.querySelectorAll(focusableElements);

            return Object.keys(nodes).map(key => nodes[key]);
        },
        // TODO: Remove
        // Deprecated - DO NOT USE
        parentFocus() {
            const elements = ['[role="dialog"]', '[role="alert"]', '[role="menu"]', '[role="tooltip"]'];

            const nodes =
                this.container && this.$refs[this.container]
                    ? this.$refs[this.container].querySelectorAll(elements)
                    : this.$el.querySelectorAll(elements);

            // As it's a div or section, by nature it's not focusable so add tabindex attribute
            nodes.forEach(node => {
                node.setAttribute('tabindex', '0');
            });

            return Object.keys(nodes).map(key => nodes[key]);
        },
        // Check if current activeElement is focusable element
        isFocusableElement() {
            return (
                focusableElements.findIndex(selector => {
                    return document.activeElement.matches(selector);
                }) >= 0
            );
        },
        // Check if current activeElement is present inside container
        isFocusInsideContainer() {
            const container = this.container && this.$refs[this.container] ? this.$refs[this.container] : this.$el;
            return container.contains(document.activeElement);
        },
    },
};

export default MdsTrapFocus;
